<div class="outer-container d-flex flex-column">
    <div class="heading-container d-flex justify-content-between">
        <div class="heading">{{'notification.notifications' | translate}}</div>
        <div class="view-all-link cursor-pointer" *ngIf="notificationList?.length" (click)="viewAllClick()">{{'notification.ViewAll' | translate}}</div>
    </div>
    <div class="list-container d-flex flex-column" *ngIf="notificationList?.length">
        <div *ngFor="let notification of notificationList">
            <div *ngFor="let item of notification.notifications" class="list-item d-flex flex-column" (click)=notificationClick(item)
                [ngClass]="{'list-item-active':!item.isRead }">
                <div class="heading">{{item.title}} <div class="unread"
                        *ngIf="!item.isRead"></div>
                </div>
                <div class="content">{{item.body}}</div>
            </div>
        </div>
    </div>

    <div class="list-container no-data d-flex" *ngIf="!notificationList?.length">
        <img class="no-promotion-img" src="./images/no-notification.svg">
        {{'notification.noNotification' | translate}}
    </div>
</div>